<template>
  <div class="popup z-index-10-fg confirmation small-popup link-contact-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Link a Company</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('cancel')" />
      </div>
      <div class="popup-body">
        <SearchMenu v-model="searchText" :options="searchResults" placeholder="Search for a company..." @updateContact="handleCompanySelect" @forceOptionsUpdate="forceUpdate" />
      </div>
      <div class="popup-footer">
        <button @click="$emit('cancel')" class="text-btn">Cancel</button>
        <button @click="handleLink" class="square-btn" :disabled="!selectedCompany">Link</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import SearchMenu from './inputs/SearchMenu.vue';
import useSearchWorker from '../composables/useSearchWorker.js';
import useCompaniesQuery from '../composables/useCompaniesQuery.js';
import useContactsQuery from '../composables/useContactsQuery.js';

export default {
  name: 'LinkContactToCompany',
  components: {
    SearchMenu,
  },
  emits: ['link', 'cancel'],
  setup() {
    // Initialize the queries
    useCompaniesQuery.useCompaniesQuery();
    useContactsQuery.useContactsQuery();

    // Use search worker
    const { searchResults, searchText, forceUpdate, type } = useSearchWorker();
    type.value = 'companies';

    return {
      searchResults,
      searchText,
      forceUpdate,
    };
  },
  data() {
    return {
      selectedCompany: null,
    };
  },
  methods: {
    handleCompanySelect(option) {
      if (option && option.type === 'company') {
        this.selectedCompany = option;
        this.searchText = option.text;
      } else {
        this.selectedCompany = null;
      }
    },
    handleLink() {
      if (this.selectedCompany) {
        this.$emit('link', this.selectedCompany);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.link-contact-popup {
  width: 30rem;
}
</style>
